export function equityTieOutNeedsWarning(difference: number, tolerance = 0.02): boolean {
  return Math.abs(difference) > tolerance
}
